import { getAudioLinksById, clearAudioLinks } from '@actions/transcripts';
import { connect } from 'react-redux';
import {
  selectSignedRecordings,
  selectIsFetchingSignedRecordings,
} from '@selectors/transcripts';
import DownloadAudioButton from './DownloadAudioButton';

const mapStateToProps = (state) => ({
  isFetching: selectIsFetchingSignedRecordings(state),
  recordings: selectSignedRecordings(state),
});

const mapDispatchToProps = {
  getAudioLinksById,
  clearAudioLinks,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadAudioButton);



// WEBPACK FOOTER //
// ./components/molecules/DownloadAudioButton/index.js